import { render, staticRenderFns } from "./MedicalCheckUp.vue?vue&type=template&id=6c7a9126"
import script from "./MedicalCheckUp.vue?vue&type=script&lang=js"
export * from "./MedicalCheckUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports